/*
 * This bundle is intended to hold all of the admin-only styles and JS (which we're now loading separately, only in the admin)
 */

/* Sitefinity Page Editor overrides - for fixing the appearance of the drag/drop page editor */
require('./styles/_sf-editor-overrides.scss');

/* Kendo Editor styles - for adjusting the style of the content editor Visual tab */
require('./styles/_sf-kendo-editor-styles.scss');